import { SpecValue } from "@/types/specList";

export const addPreviousValuesToSpecValues = (
  masterSpecSpecValues: SpecValue[],
  selectedSpecListValues: SpecValue[],
  includeUnchangedMasterSpecs = false,
) => {
  if (masterSpecSpecValues.length === 0) {
    return selectedSpecListValues;
  }

  const result = masterSpecSpecValues.reduce(
    (acc, masterSpecValue) => {
      const currentSpecValue = selectedSpecListValues.find(
        (v) => v.specId === masterSpecValue.specId,
      );

      if (currentSpecValue) {
        acc.customSpecs.push({ ...currentSpecValue, previousValues: masterSpecValue });
      } else if (includeUnchangedMasterSpecs) {
        acc.masterSpecs.push({ ...masterSpecValue });
      }

      return acc;
    },
    { customSpecs: [] as SpecValue[], masterSpecs: [] as SpecValue[] },
  );

  return [...result.customSpecs, ...result.masterSpecs];
};
